export default [
  {
    path: '/useterms',
    name: 'UseTerms',
    component: () => import('App/useterms/UseTermsForm.vue'),
    meta: {
      itemActive: 'UseTerms',
    },
  },
];
